import * as yup from 'yup';

import validationSchemaGeneral from './validationSchemaGeneral';
import validationSchemaOpeningHours from './validationSchemaOpeningHours';

const validationSchema = validationSchemaGeneral.required().concat(validationSchemaOpeningHours.required());

export type ValidDraftVenueFormValues = yup.InferType<typeof validationSchema>;

export default validationSchema;
